export const CurrencyType = 'currency';
export const DateType = 'date';
export const NumberType = 'number';
export const PercentType = 'percent';
export const StringType = 'string';
